import { PAYMENT_REDIRECTED_QUERY_PARAM } from '~/types/payment';
import { getPaymentId } from '~/lib/services/payment/paymentIdStorage';

/**
 * Validates that required payment data exists in localStorage when returning from a 3DS redirect.
 * If data is missing, removes the redirect query param and shows an error notification.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (to.query[PAYMENT_REDIRECTED_QUERY_PARAM] !== 'true') return;

  const paymentId = getPaymentId();
  if (paymentId) return;

  const { t } = useI18n();
  const notificationsStore = useNotificationsStore();

  notificationsStore.add({
    status: 'danger',
    message: t('ui.error.tryAgainRequest'),
    timeout: 7000,
  });

  const { [PAYMENT_REDIRECTED_QUERY_PARAM]: _, ...query } = to.query;
  return navigateTo({ path: to.path, query }, { replace: true });
});
